module.exports = __webpack_public_path__ + "images/emoji/arrow_upper_right.177765f3cb5e3ec8f558.png";